import { useTranslation } from '@msdk/common'
import { OptionSetDirection } from '@msdk/definitions'
import { CheckBoxGroup, CheckboxSingle, OptionItem, RadioGroup, RadioGroupDirection, Select } from '@msdk/ui'
import React, { ReactElement } from 'react'

export type OptionsetType =
  | 'Dropdown'
  | 'DropdownMultiselect'
  | 'RadioButton'
  | 'RadioButtonMultiple'
  | 'Checkbox'
  | 'SlideToggle'
  | 'CheckboxSingle'

interface Props {
  label: string
  options: OptionItem[]
  value: OptionItem | OptionItem[]
  onChange: (value: string | string[]) => void
  type: OptionsetType
  disabled: boolean
  direction: OptionSetDirection
  canBeUnselected: boolean
}

export function ConditionalOptionsetRenderer(props: Props) {
  const t = useTranslation()

  const onChange = (val: string | string[]) => {
    props.onChange(val)
  }

  const getValueArray = () => {
    if (props.value) {
      return Array.isArray(props.value) ? props.value : [props.value]
    }
    return []
  }

  function onClear() {
    props.onChange([])
  }

  const renderer: Record<OptionsetType, ReactElement> = {
    CheckboxSingle: (
      <CheckboxSingle
        disabled={props.disabled}
        label={props.label}
        options={props.options}
        value={props.value as OptionItem}
        onChange={onChange}
      />
    ),
    Checkbox: (
      <CheckBoxGroup disabled={props.disabled} options={props.options} value={getValueArray()} onChange={onChange} />
    ),
    Dropdown: (
      <Select
        disabled={props.disabled}
        label={props.label}
        options={props.options}
        value={getValueArray()}
        onChange={onChange}
        onClear={onClear}
        canBeUnselected={props.canBeUnselected}
      />
    ),
    DropdownMultiselect: (
      <Select
        disabled={props.disabled}
        label={props.label}
        options={props.options}
        value={getValueArray()}
        onChange={onChange}
        onClear={onClear}
        multi
        canBeUnselected={props.canBeUnselected}
      />
    ),
    RadioButton: (
      <RadioGroup
        direction={
          props.direction === OptionSetDirection.Vertical
            ? RadioGroupDirection.Vertical
            : RadioGroupDirection.Horizontal
        }
        disabled={props.disabled}
        options={props.options}
        value={getValueArray()}
        onChange={onChange}
      />
    ),
    RadioButtonMultiple: <p>UNSUPPORTED</p>,
    SlideToggle: <p>UNSUPPORTED</p>,
  }

  return <>{renderer[props.type]}</>
}
